import React, { useContext } from "react";

interface Props {
    callusNumber?: string;
    callusText?: string;
    isMobileSize?: any;
    onCallUsNowClick?: any;
    classNames?: string;
}

const CallUsNowButton = ({ callusNumber, callusText, isMobileSize, onCallUsNowClick, classNames }: Props) => {
    return (
        <a
            onClick={onCallUsNowClick}
            className= {classNames}
            {...(isMobileSize && callusNumber
                ? { href: 'tel:' + callusNumber }
                : {})}
        >
            {callusText}
        </a>
    );
};

export default CallUsNowButton;
